<template>
  <v-container flex-column text-xs-center id="resultDiv">
    <template v-if="isGeneralError">
      <div class="title font-weight-bold">{{$t('qrCode.unexpectedProblem')}}</div>
      <div class="title font-weight-bold">{{$t('qrCode.pleaseReload')}}</div>
    </template>
    <template v-else>
      <span class="title font-weight-bold">
        {{$t('qrCode.unableToUploadWithQR')}}
      </span>
      <v-container>
        <span>QR: {{guid}}</span>
        <div class="pt-2">
          <span>{{$t('qrCode.redirectInTen')}}</span>
          <v-spacer/>
          <button class="clickable-text" @click="$emit('reload')">{{$t('qrCode.redirectNow')}}</button>
        </div>
      </v-container>
    </template>
  </v-container>
</template>

<script>
export default {
  name: 'GuidError',
  props: {
    guid: {
      type: String,
      required: false
    },
    isGeneralError: {
      type: Boolean,
      required: true
    }
  },
  emits: ['reload']
}
</script>
